import { List, Menu, MenuItem, Skeleton } from '@mui/material'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

interface StyledListProps {
  $hideHeader: boolean
  $menuCollapsed: boolean
}

interface StyledGroupProps {
  $menuCollapsed: boolean
}

interface StyledTitleProps {
  $menuCollapsed: boolean
}

interface StyledItemProps {
  selected: boolean
}

interface ExpandIconProps {
  open: boolean
}

interface StyledCollapseProps {
  $menuCollapsed: boolean
}

interface StyledMenuCollapsedProps {
  $menuCollapsed: boolean
}

export const StyledList = styled(List)<StyledListProps>`
  && {
    min-width: ${(props) => (props.$menuCollapsed ? '60px' : '300px')};
    max-width: ${(props) => (props.$menuCollapsed ? '60px' : '300px')};
    padding: 8px 16px 0 16px;
    border-right: 1px solid ${(props) => props.theme.colors.grayBorder};
    height: ${(props) =>
      props.$hideHeader ? 'calc(100vh - 8px)' : 'calc(100vh - 108px)'};
    overflow: auto;
    transition:
      height 0.3s ease,
      padding-right 0.3s ease,
      min-width 0.3s ease,
      max-width 0.3s ease;
    padding-right: calc(
      100% - 100vw + 8px
    ); /* Compensar a largura da barra de rolagem */

    ::-webkit-scrollbar {
      width: 8px;
    }

    ::-webkit-scrollbar-track {
      background: ${(props) => props.theme.colors.graySemiDark};
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${(props) => props.theme.colors.gray};
      border-radius: 10px;
      border: 2px solid ${(props) => props.theme.colors.graySemiDark};
    }

    scrollbar-width: thin;
    scrollbar-color: ${(props) => props.theme.colors.gray}
      ${(props) => props.theme.colors.graySemiDark};
  }
`

export const StyledGroup = styled.li<StyledGroupProps>`
  padding: ${(props) => (props.$menuCollapsed ? '8px 0' : '8px 0 8px 8px')};
  border-bottom: 1px solid ${(props) => props.theme.colors.grayBorder};
  transition:
    padding 0.3s ease,
    background 0.3s ease;

  &:hover {
    background: ${(props) =>
      props.$menuCollapsed ? props.theme.colors.grayBorder : ''};
  }
`

export const GroupTitle = styled.div<StyledTitleProps>`
  display: flex;
  align-items: center;
  justify-content: ${(props) =>
    props.$menuCollapsed ? 'center' : 'space-between'};
  cursor: pointer;
  height: 40px;
  padding-right: ${(props) => (props.$menuCollapsed ? '0' : '8px')};
  transition: justify-content 0.3s ease;

  span {
    display: flex;
    align-items: center;
    gap: 8px;
    text-transform: uppercase;
    font-size: 16px;
    font-weight: 700;
  }
`

export const StyledGroupItem = styled.ul`
  margin-top: 8px;
  padding-left: 0;
`

export const StyledItemLink = styled(Link)`
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  color: ${(props) => props.theme.colors.white};
`

export const StyledItem = styled.li<StyledItemProps>`
  display: flex;
  align-items: center;
  gap: 8px;
  list-style: none;
  height: 40px;
  padding: 3.5px 20px;
  padding-left: ${(props) => (props.selected ? '30px' : '20px')};
  border-top: 1px solid ${(props) => props.theme.colors.grayBorder};
  transition:
    background 0.2s ease,
    padding-left 0.3s ease;
  background: ${(props) =>
    props.selected ? props.theme.colors.grayBorder : 'transparent'};

  &:hover {
    background: ${(props) => props.theme.colors.grayBorder};
  }
`

export const ExpandIcon = styled.div<ExpandIconProps>`
  display: flex;
  align-items: center;
  transition: transform 0.3s ease;
  transform: ${({ open }) => (open ? 'rotate(180deg)' : 'rotate(0deg)')};
`

export const StyledCollapse = styled.div<StyledCollapseProps>`
  position: sticky;
  bottom: 0;
  width: calc(100% - 32px);
  padding: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #404040;
  color: #fff;
  transition: transform 0.3s ease;

  svg {
    transition: transform 0.3s ease;
    transform: ${({ $menuCollapsed }) =>
      $menuCollapsed ? 'rotate(180deg)' : 'rotate(0deg)'};
  }
`

export const StyledMenuCollapsed = styled(Menu)<StyledMenuCollapsedProps>`
  && {
    .MuiPaper-root {
      box-shadow:
        0px 8px 12px 6px rgba(0, 0, 0, 0.15),
        0px 4px 4px 0px rgba(0, 0, 0, 0.3);
      background: ${(props) => props.theme.colors.graySemiDark};
      border-radius: 8px;
      padding: 0;
    }
  }
`

export const StyledMenuCollapsedLink = styled(Link)`
  text-decoration: none;
`

export const StyledMenuCollapsedItem = styled(MenuItem)`
  && {
    gap: 8px;
    font-size: 14px;
    font-weight: 500;
    color: ${(props) => props.theme.colors.white};
  }
`

export const StyledSkeletonList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 30px;
  padding-right: 10px;
  border-right: 1px solid ${(props) => props.theme.colors.grayBorder};
`

export const StyledSkeleton = styled(Skeleton)`
  && {
    border-radius: 4px;
    background: ${(props) => props.theme.colors.grayLight};
  }
`
